import * as React from 'react'

import ReactMarkdown from 'react-markdown'
import { Link as ReactRouterLink } from 'react-router-dom'
import rehypeRaw from 'rehype-raw'
import remarkGfm from 'remark-gfm'

import { FaqAccordion } from '../FaqAccordion/FaqAccordion'
import { Link } from '../Link/Link'

export interface FaqLink {
  internal?: {
    content?: string
  }
}

export interface FaqItemProps {
  title: string
  slug: string
  content: string
  dataItemName: string
  link?: FaqLink | string
  darkText?: boolean
}

type MarkdownComponents = NonNullable<
  React.ComponentProps<typeof ReactMarkdown>['components']
>

const markdownComponents: MarkdownComponents = {
  a({ node: _node, children, href, ...props }) {
    return (
      <Link
        href={typeof href === 'string' ? href : undefined}
        props={props}
        component={ReactRouterLink}
      >
        {children}
      </Link>
    )
  },
  p({ node: _node, ...props }) {
    return <p className="margin--regular" {...props} />
  },
}
const FaqItem = ({
  title: faqTitle,
  slug: faqId,
  content: faqContent,
  dataItemName,
  link: faqLink,
  darkText,
}: FaqItemProps) => (
  <FaqAccordion
    title={faqTitle}
    id={faqId}
    dataTestId={`${faqId}-faq-title`}
    darkText={darkText}
    // data-item-name is passed down to FaqAccordion
    dataItemName={dataItemName}
  >
    <span className="margin--regular" data-testid={`${faqId}-faq-text`}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
        {faqContent}
      </ReactMarkdown>
    </span>
    {faqLink && (
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={markdownComponents}
      >
        {(faqLink as FaqLink)?.internal?.content || ''}
      </ReactMarkdown>
    )}
  </FaqAccordion>
)

export default FaqItem
